import { Clock, Loader2, CheckCircle } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { AppLayout } from "@/components/ui-system";

const HubOperatorLayout = ({ children, user, onLogout }) => {
  const nav = [
    { name: "Pending", path: "/hub-operator", icon: Clock, testId: "nav-pending", end: true },
    { name: "In Progress", path: "/hub-operator/in-progress", icon: Loader2, testId: "nav-in-progress" },
    { name: "Completed", path: "/hub-operator/completed", icon: CheckCircle, testId: "nav-completed" },
  ];

  const headerBadge = (
    <Badge className="text-[10px] px-1.5 py-0 border-0 bg-emerald-100 text-emerald-700">Hub Ops</Badge>
  );

  return (
    <AppLayout
      variant="mobile-tabs"
      accent="green"
      brand={{ name: "Hub Operator" }}
      nav={nav}
      user={user}
      onLogout={onLogout}
      headerBadge={headerBadge}
      headerSubtitle={user?.hub_name || user?.service_city || "Pharmeasy"}
    >
      {children}
    </AppLayout>
  );
};

export default HubOperatorLayout;
